import React, {useEffect} from 'react';
import Navbar from '../Navbar';
import HeroSection from './Herosection';
import Footer from '../footer';
import WhyChoose from './WhyChoose';
import Testimonial from './Testimonial';
import Video from './Video';
import WeHelpSection from './WeHelpSection';
import Products from './Products';
import BackToTop from '../BackToTop';





const HomePage = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, []);
  return (
    
    <section>
      <Navbar />

      <HeroSection />

      <WhyChoose />

      <Products />

      <Video />

      <WeHelpSection />

      <Testimonial />

      <Footer />

      <BackToTop />
    </section>
    
  )
}

export default HomePage